import {useSelector} from 'react-redux';
import {UserAvatar} from '~/common/components/MegaNav/MegaNavVariant/components/GlobalNav/components/Login/components/AccountPreview/UserAvatar';
import {selectUser, userHasSubscriptionPlan} from '~/common/fabric/User/reducers/user';
import {Typography} from '~library/atoms/Typography';

import * as styles from './UserInfo.module.scss';

export const UserInfo = () => {
  const user = useSelector(selectUser);
  const hasSubscriptionPlan = useSelector(userHasSubscriptionPlan);
  const fullName = user.full_name || user.userName;

  return (
    <div className={styles.userInfoContainer}>
      <UserAvatar height={32} width={32} />
      <div className={styles.userInfoDetails}>
        <Typography variant="paragraph2" semibold className={styles.userInfo}>
          {fullName}
        </Typography>
        <Typography variant="paragraph3" color="pebble" className={styles.userInfo}>
          {user.email}
        </Typography>
      </div>
      {hasSubscriptionPlan && (
        <Typography variant="paragraph4" semibold className={styles.userInfoBadge}>
          PRO
        </Typography>
      )}
    </div>
  );
};
